import {
  getAragCaseByCaseAssistNumber,
  getAragCasesByMemberId,
  type GetAragCasesByMemberId,
  type CaseDetailsPage,
} from '@/cloudFunctions/arag';
import { Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
const MemberIdResults = ({
  results,
  onLoadDetailsRequested,
}: {
  results: GetAragCasesByMemberId.Case[];
  onLoadDetailsRequested: (row: GetAragCasesByMemberId.Case) => void;
}) => {
  return (
    <Paper p='md' withBorder>
      <Title order={4} mb='sm'>
        Search Results ({results.length} found)
      </Title>
      {results.length === 0 ? (
        <Text c='dimmed'>No cases found matching your search criteria.</Text>
      ) : (
        <Stack gap='md'>
          {results.map((caseResult, idx) => (
            <Paper key={idx} p='md' withBorder radius='md'>
              <Group justify='space-between' align='flex-start'>
                <Stack gap='xs' style={{ flex: 1 }}>
                  <LabelValuePair
                    label='CaseAssist Number'
                    value={caseResult.caseAssistNumber}
                  />
                  <LabelValuePair
                    label='Member ID'
                    value={caseResult.memberId}
                  />
                  <LabelValuePair
                    label='Member Name'
                    value={caseResult.memberName}
                  />
                  <LabelValuePair
                    label='Legal Matter'
                    value={caseResult.matterType}
                  />
                </Stack>

                <Button
                  type='button'
                  onClick={() => {
                    onLoadDetailsRequested(caseResult);
                  }}
                >
                  Load details
                </Button>
              </Group>
            </Paper>
          ))}
        </Stack>
      )}
    </Paper>
  );
};

export default MemberIdResults;

const LabelValuePair = ({ label, value }: { label: string; value: string }) => {
  return (
    <Group gap='xs'>
      <Text size='sm' fw={600} c='gray.8'>
        {label}:
      </Text>
      <Text size='sm'>{value}</Text>
    </Group>
  );
};
